import { render, staticRenderFns } from "./AutoupdateList.vue?vue&type=template&id=5d1f0dd3&"
import script from "./AutoupdateList.vue?vue&type=script&lang=js&"
export * from "./AutoupdateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1f0dd3')) {
      api.createRecord('5d1f0dd3', component.options)
    } else {
      api.reload('5d1f0dd3', component.options)
    }
    module.hot.accept("./AutoupdateList.vue?vue&type=template&id=5d1f0dd3&", function () {
      api.rerender('5d1f0dd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Autoupdate/AutoupdateList.vue"
export default component.exports